// extracted by mini-css-extract-plugin
module.exports = {"metric-cell":"MetricCells_metric-cell__3013Y","today":"MetricCells_today__3xFIH","value":"MetricCells_value__BzcS9","comparative":"MetricCells_comparative__2y-uR"};